import { render, staticRenderFns } from "./DecisionTargetList.vue?vue&type=template&id=be3c61ec&"
import script from "./DecisionTargetList.vue?vue&type=script&lang=js&"
export * from "./DecisionTargetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports